import { css } from 'styled-components'

const secondaryButtonTemplate = () => css`
  background: var(--sl-bg-muted);
  color: var(--sl-fg-muted);

  &:hover {
    background: var(--sl-bg-muted-hover);
    color: var(--sl-fg-muted-hover);
  }

  &.active {
    background: var(--sl-bg-muted-pressed);
    color: var(--sl-fg-muted-pressed);
  }

  &:focus-visible {
    box-shadow: var(--sl-focus-ring-base);
    background: var(--sl-bg-muted-hover);
    color: var(--sl-fg-muted-hover);
  }

  &:disabled {
    background: var(--sl-bg-base-disabled);
    color: var(--sl-fg-base-disabled);
  }
`

export default secondaryButtonTemplate
